<template>
  <div>
    <v-dialog
      v-model="showDialog"
      persistent
      fullscreen
      max-width="800px"
    >
      <v-card>
        <validation-observer
          v-slot="{ handleSubmit }"
        >
          <form @submit.prevent="handleSubmit(save)">
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-skeleton-loader
                  class="mx-auto"
                  max-width="300"
                  type="card"
                  :loading="loadingMachine"
                >
                  <v-row>
                    <span class="projected-values">Banco Inicial:</span> <span class="projected-labels">{{ shopMachine.initialRefill }}</span>
                    <span class="projected-values">Banco:</span> <span class="projected-labels">{{ projectedValues.bank }}</span>
                    <span class="projected-values">Efectivo:</span> <span class="projected-labels">{{ projectedValues.cashToGo }} </span>
                    <span class="projected-values">Pago:</span> <span class="projected-labels">{{ projectedValues.balanceToPay }} </span>
                  </v-row>
                  <v-divider class="mt-3" />
                  <v-row>
                    <v-col
                      cols="12"
                      sm="6"
                      md="3"
                    >
                      <v-menu
                        v-model="visitDateMenu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                        disabled
                      >
                        <template v-slot:activator="{ on }">
                          <validation-provider
                            v-slot="{ errors }"
                            rules="required"
                            name="shopMachineVisit.visitDate"
                          >
                            <v-text-field
                              v-model="shopMachineVisit.visitDate"
                              :label="$t('fields.shopMachineVisit.visitDate')"
                              persistent-hint
                              prepend-icon="mdi-calendar"
                              readonly
                              :error-messages="errors"
                              v-on="on"
                            />
                          </validation-provider>
                        </template>
                        <v-date-picker
                          v-model="shopMachineVisit.visitDate"
                          no-title
                          :locale="$i18n.locale"
                          @input="visitDateMenu = false"
                        />
                      </v-menu>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="3"
                    >
                      <v-text-field
                        v-model.number="shopMachineVisit.appVisitDate"
                        :label="$t('fields.shopMachineVisit.appVisitDate')"
                        readonly
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="3"
                    >
                      <v-text-field
                        v-model.number="shopMachineVisit.createdByUserUserName"
                        :label="$t('fields.shopMachineVisit.createdByUser')"
                        readonly
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="3"
                    >
                      <v-text-field
                        v-model.number="shopMachineVisit.modifiedByUserUserName"
                        :label="$t('fields.shopMachineVisit.updatedByUser')"
                        readonly
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="3"
                    >
                      <validation-provider
                        v-slot="{ errors }"
                        rules="numeric|required"
                        name="shopMachineVisit.inElectronicMarker"
                      >
                        <v-text-field
                          v-model.number="shopMachineVisit.inElectronicMarker"
                          :label="$t('fields.shopMachineVisit.inElectronicMarker')"
                          :error-messages="errors"
                          @keyup="calculateMarkers"
                        />
                      </validation-provider>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="3"
                    >
                      <validation-provider
                        v-slot="{ errors }"
                        rules="numeric|required"
                        name="shopMachineVisit.outElectronicMarker"
                      >
                        <v-text-field
                          v-model.number="shopMachineVisit.outElectronicMarker"
                          :label="$t('fields.shopMachineVisit.outElectronicMarker')"
                          :error-messages="errors"
                          @keyup="calculateMarkers"
                        />
                      </validation-provider>
                    </v-col>
                    <!-- <v-col
                      cols="12"
                      sm="6"
                      md="3"
                    >
                      <validation-provider
                        v-slot="{ errors }"
                        rules="integer"
                        name="shopMachineVisit.inOutElectronicDifferent"
                      >
                        <v-text-field
                          v-model.number="shopMachineVisit.inOutElectronicDifferent"
                          readonly
                          :label="$t('fields.shopMachineVisit.inOutElectronicDifferent')"
                          :error-messages="errors"
                        />
                      </validation-provider>
                    </v-col> -->
                    <v-col
                      cols="12"
                      sm="6"
                      md="3"
                    >
                      <validation-provider
                        v-slot="{ errors }"
                        rules="numeric|required"
                        name="shopMachineVisit.inMechanicMarker"
                      >
                        <v-text-field
                          v-model.number="shopMachineVisit.inMechanicMarker"
                          :label="$t('fields.shopMachineVisit.inMechanicMarker')"
                          :error-messages="errors"
                          @keyup="calculateMarkers"
                        />
                      </validation-provider>
                    </v-col>
                    <!-- <v-col
                      cols="12"
                      sm="6"
                      md="3"
                    >
                      <v-text-field
                        v-model.number="shopMachineVisit.inMechanicMarkerExchange"
                        :label="$t('fields.shopMachineVisit.inMechanicMarkerExchange')"
                        @keyup="calculateMarkers"
                      />
                    </v-col> -->
                    <v-col
                      cols="12"
                      sm="6"
                      md="3"
                    >
                      <validation-provider
                        v-slot="{ errors }"
                        rules="numeric|required"
                        name="shopMachineVisit.outMechanicMarker"
                      >
                        <v-text-field
                          v-model.number="shopMachineVisit.outMechanicMarker"
                          :label="$t('fields.shopMachineVisit.outMechanicMarker')"
                          :error-messages="errors"
                          @keyup="calculateMarkers"
                        />
                      </validation-provider>
                    </v-col>
                    <!-- <v-col
                      cols="12"
                      sm="6"
                      md="6"
                    >
                      <v-text-field
                        v-model.number="shopMachineVisit.outMechanicMarkerExchange"
                        :label="$t('fields.shopMachineVisit.outMechanicMarkerExchange')"
                        @keyup="calculateMarkers"
                      />
                    </v-col> -->
                    <!-- <v-col
                      cols="12"
                      sm="6"
                      md="4"
                    >
                      <validation-provider
                        v-slot="{ errors }"
                        rules="integer"
                        name="shopMachineVisit.inOutMechanicDifferent"
                      >
                        <v-text-field
                          v-model.number="shopMachineVisit.inOutMechanicDifferent"
                          readonly
                          :label="$t('fields.shopMachineVisit.inOutMechanicDifferent')"
                          :error-messages="errors"
                        />
                      </validation-provider>
                    </v-col> -->
                    <v-col
                      cols="12"
                      sm="6"
                      md="3"
                    >
                      <v-text-field
                        v-model.number="shopMachineVisit.inElectronicDifferentRaw"
                        readonly
                        :label="$t('fields.shopMachineVisit.inElectronicDifferent')"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="3"
                    >
                      <v-text-field
                        v-model.number="shopMachineVisit.outElectronicDifferentRaw"
                        readonly
                        :label="$t('fields.shopMachineVisit.outElectronicDifferent')"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="3"
                    >
                      <v-text-field
                        v-model.number="shopMachineVisit.inMechanicDifferentRaw"
                        readonly
                        :label="$t('fields.shopMachineVisit.inMechanicDifferent')"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="3"
                    >
                      <v-text-field
                        v-model.number="shopMachineVisit.outMechanicDifferentRaw"
                        readonly
                        :label="$t('fields.shopMachineVisit.outMechanicDifferent')"
                      />
                    </v-col>
                    <!-- <v-col
                      cols="12"
                      sm="3"
                      md="3"
                    >
                      <v-text-field
                        v-model="shopMachineVisit.shopPercentage"
                        readonly
                        :label="$t('fields.shopMachineVisit.shopPercentage')"
                      />
                    </v-col> -->
                    <v-col
                      cols="12"
                      sm="4"
                      md="4"
                    >
                      <v-text-field
                        v-model.number="shopMachineVisit.profit"
                        readonly
                        :label="$t('fields.shopMachineVisit.profit')"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      sm="4"
                      md="4"
                    >
                      <validation-provider
                        v-slot="{ errors }"
                        rules="numeric|required"
                        name="shopMachineVisit.physicCashProfit"
                      >
                        <v-text-field
                          v-model.number="shopMachineVisit.physicCashProfit"
                          :label="$t('fields.shopMachineVisit.physicCashProfit')"
                          :error-messages="errors"
                          :disabled="shopMachineVisit.type === 'S'"
                          @keyup="calculateMarkers"
                        />
                      </validation-provider>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="4"
                      md="4"
                    >
                      <validation-provider
                        v-slot="{ errors }"
                        rules="numeric|required"
                        name="shopMachineVisit.refill"
                      >
                        <v-text-field
                          v-model.number="shopMachineVisit.refill"
                          :label="$t('fields.shopMachineVisit.refill')"
                          :error-messages="errors"
                          :disabled="shopMachineVisit.type === 'S'"
                          @keyup="calculateMarkers"
                        />
                      </validation-provider>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="4"
                      md="4"
                    >
                      <v-text-field
                        v-model.number="shopMachineVisit.shopProfit"
                        readonly
                        :label="$t('fields.shopMachineVisit.shopProfit')"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      sm="4"
                      md="4"
                    >
                      <validation-provider
                        v-slot="{ errors }"
                        rules="numeric|required"
                        name="shopMachineVisit.shopProfitDelivey"
                      >
                        <v-text-field
                          v-model.number="shopMachineVisit.shopProfitDelivey"
                          :label="$t('fields.shopMachineVisit.shopProfitDelivey')"
                          :error-messages="errors"
                          :disabled="shopMachineVisit.type === 'S'"
                          @keyup="calculateMarkers"
                        />
                      </validation-provider>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="4"
                      md="4"
                    >
                      <validation-provider
                        v-slot="{ errors }"
                        rules="numeric|required"
                        name="shopMachineVisit.depositBalancePayToShop"
                      >
                        <v-text-field
                          v-model.number="shopMachineVisit.depositBalancePayToShop"
                          :label="$t('fields.shopMachineVisit.depositBalancePayToShop')"
                          :error-messages="errors"
                          :disabled="shopMachineVisit.type === 'S'"
                          @keyup="calculateMarkers"
                        />
                      </validation-provider>
                    </v-col>
                  </v-row>
                </v-skeleton-loader>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer />
              <v-btn
                color="warning"
                depressed
                rounded
                @click="close"
              >
                {{ $t('cancel') }}
              </v-btn>
              <v-btn
                color="info"
                depressed
                rounded
                type="submit"
                :loading="loadingSave"
              >
                {{ $t('save') }}
              </v-btn>
            </v-card-actions>
          </form>
        </validation-observer>
      </v-card>
    </v-dialog>

    <base-material-snackbar
      v-model="showErrorMessage"
      type="error"
      v-bind="{
        ['top']: true,
        ['center']: true,
        ['vertical']: true
      }"
    >
      {{ errorMessage }}
    </base-material-snackbar>
  </div>
</template>

<script>
  import filters from '@/common/filters'
  import { repositoryFactory } from '@/api/repositoryFactory'
  import dateUtils from '@/common/dateUtils'
  const shopMachineVisitsRespository = repositoryFactory.get('shopMachineVisits')

  export default {
    name: 'ShopMachineVisitDialog',
    mixins: [filters],
    props: {
      show: {
        type: Boolean,
        default: false,
      },
      shopMachineVisitId: {
        type: String,
        default: '',
      },
      method: {
        type: String,
        default: '',
      },
      shopMachine: {
        type: Object,
        default: function () {
          return { }
        },
      },
    },
    data: () => ({
      showErrorMessage: false,
      errorMessage: '',
      showDialog: false,
      loadingMachine: false,
      visitDateMenu: false,
      loadingSave: false,
      shopMachineVisit: {
        visitDate: new Date().toISOString().substr(0, 10),
        inMechanicMarker: 0,
        outMechanicMarker: 0,
        inElectronicMarker: 0,
        outElectronicMarker: 0,
        inCreditMarker: 0,
        outCreditMarker: 0,
      },
      shopMachineVisitDefault: {
        visitDate: new Date().toISOString().substr(0, 10),
        inMechanicMarker: 0,
        outMechanicMarker: 0,
        inElectronicMarker: 0,
        outElectronicMarker: 0,
        inCreditMarker: 0,
        outCreditMarker: 0,
      },
      oldShopMachineVisit: {},
      shopMachinePreviusVisit: {},
      projectedValues: {
        cash: 0,
        balanceToPay: 0,
      },
    }),
    computed: {
      formTitle () {
        return this.method === 'add' ? this.$t('add-visit') : this.$t('edit-visit')
      },
    },
    watch: {
      show (val) {
        this.showDialog = val
        if (val === true) {
          this.fetchData()
        }
      },
    },
    methods: {
      fetchData () {
        var self = this
        self.loadingMachine = true
        var id = this.shopMachineVisitId
        shopMachineVisitsRespository.getById(id).then(response => {
          self.shopMachineVisit = Object.assign({}, response.data.data)
          self.oldShopMachineVisit = Object.assign({}, response.data.data)
          self.shopMachineVisit.visitDate = dateUtils.formatLongDate(self.shopMachineVisit.visitDate)
          self.shopMachineVisit.appVisitDate = dateUtils.formatLongDate(self.shopMachineVisit.appVisitDate)
          shopMachineVisitsRespository.getPrevius(id).then(response => {
            self.loadingMachine = false
            if (response.data.data == null) {
              self.shopMachinePreviusVisit = null
            } else {
              self.shopMachinePreviusVisit = Object.assign({}, response.data.data)
            }
            self.calculateMarkers()
          }).catch(err => {
            self.loadingMachine = false
            alert(err)
          })
        }).catch(err => {
          self.loadingMachine = false
          alert(err)
        })
      },

      close () {
        this.$emit('change-edit-dialog', false)
        this.showDialog = false
        this.$nextTick(() => {
          this.shopMachineVisit = Object.assign({}, this.shopMachineVisitDefault)
        })
      },

      save () {
        if (this.method === 'edit') {
          var self = this

          var data = {
            data: Object.assign(self.shopMachineVisit),
            userId: self.$store.state.user.id,
          }

          data.data.visitDate = dateUtils.formatLongDate(data.data.visitDate)
          data.data.appVisitDate = dateUtils.formatLongDate(data.data.appVisitDate)

          self.loadingSave = true
          shopMachineVisitsRespository.updateShopMachineVisit(data, self.shopMachineVisit.id).then(response => {
            if (response.data.isValid) {
              this.close()
            } else {
              self.showErrorMessage = true
              self.errorMessage = response.data.errorMessages[0]
            }
            self.loadingSave = false
          }).catch(err => {
            self.errorMessage = err
            self.showErrorMessage = true
            self.loadingSave = false
          })
        } else {
          this.items.push(this.shopMachineVisit)
        }
      },
      calculateMarkers () {
        this.shopMachineVisit.inOutMechanicDifferent = this.shopMachineVisit.inMechanicMarker - this.shopMachineVisit.outMechanicMarker
        this.shopMachineVisit.inOutElectronicDifferent = this.shopMachineVisit.inElectronicMarker - this.shopMachineVisit.outElectronicMarker

        // calculo diferencia mecanicos
        if (this.shopMachineVisit.inMechanicMarker >= this.shopMachinePreviusVisit.inMechanicMarker) {
          this.shopMachineVisit.inMechanicDifferent = this.shopMachineVisit.inMechanicMarker - this.shopMachinePreviusVisit.inMechanicMarker
        } else {
          this.shopMachineVisit.inMechanicDifferent = (this.shopMachineVisit.inMechanicMarker - this.shopMachinePreviusVisit.inMechanicMarker) + Math.floor((this.shopMachinePreviusVisit.inMechanicMarker - this.shopMachineVisit.inMechanicMarker) / Math.pow(10, this.shopMachine.markerLong) + 1) * Math.pow(10, this.shopMachine.markerLong)
        }
        if (this.shopMachineVisit.outMechanicMarker >= this.shopMachinePreviusVisit.outMechanicMarker) {
          this.shopMachineVisit.outMechanicDifferent = this.shopMachineVisit.outMechanicMarker - this.shopMachinePreviusVisit.outMechanicMarker
        } else {
          this.shopMachineVisit.outMechanicDifferent = (this.shopMachineVisit.outMechanicMarker - this.shopMachinePreviusVisit.outMechanicMarker) + Math.floor((this.shopMachinePreviusVisit.outMechanicMarker - this.shopMachineVisit.outMechanicMarker) / Math.pow(10, this.shopMachine.markerLong) + 1) * Math.pow(10, this.shopMachine.markerLong)
        }

        // calculo diferencia electronicos
        this.shopMachineVisit.outElectronicDifferent = this.shopMachineVisit.outElectronicMarker - this.shopMachinePreviusVisit.outElectronicMarker
        this.shopMachineVisit.inElectronicDifferent = this.shopMachineVisit.inElectronicMarker - this.shopMachinePreviusVisit.inElectronicMarker

        // se guardan los valores crudos de las diferencias
        this.shopMachineVisit.outMechanicDifferentRaw = this.shopMachineVisit.outMechanicDifferent
        this.shopMachineVisit.inMechanicDifferentRaw = this.shopMachineVisit.inMechanicDifferent
        this.shopMachineVisit.outElectronicDifferentRaw = this.shopMachineVisit.outElectronicDifferent
        this.shopMachineVisit.inElectronicDifferentRaw = this.shopMachineVisit.inElectronicDifferent

        // redondeo
        this.shopMachineVisit.inElectronicDifferent = Math.floor(this.shopMachineVisit.inElectronicDifferent / this.shopMachineVisit.creditExchangeRate) * this.shopMachineVisit.denominationExchangeRate
        this.shopMachineVisit.outElectronicDifferent = Math.floor(this.shopMachineVisit.outElectronicDifferent / this.shopMachineVisit.creditExchangeRate) * this.shopMachineVisit.denominationExchangeRate
        this.shopMachineVisit.inMechanicDifferent = Math.floor(this.shopMachineVisit.inMechanicDifferent / this.shopMachineVisit.creditExchangeRateMechanic) * this.shopMachineVisit.denominationExchangeRateMechanic
        this.shopMachineVisit.outMechanicDifferent = Math.floor(this.shopMachineVisit.outMechanicDifferent / this.shopMachineVisit.creditExchangeRateMechanic) * this.shopMachineVisit.denominationExchangeRateMechanic

        // calculo del profit
        if (this.shopMachineVisit.isMechanicCalculation) {
          this.shopMachineVisit.profit = this.shopMachineVisit.inMechanicDifferent - this.shopMachineVisit.outMechanicDifferent
        } else {
          this.shopMachineVisit.profit = this.shopMachineVisit.inElectronicDifferent - this.shopMachineVisit.outElectronicDifferent
        }

        // calculo del shop profit
        this.shopMachineVisit.shopProfit = parseFloat((this.shopMachineVisit.profit / 10000 * this.shopMachineVisit.shopPercentage).toFixed()) * 100

        // calulos de los efectivos
        var tempBank = this.shopMachine.bank
        var tempBalanceToPay = this.shopMachine.balancePayToShop

        // tempBank -= this.oldShopMachineVisit.profit < 0 && this.oldShopMachineVisit.refill > 0 && this.oldShopMachineVisit.refill > -(this.oldShopMachineVisit.profit) ? this.oldShopMachineVisit.refill - (-this.oldShopMachineVisit.profit) : 0
        // tempBank -= this.oldShopMachineVisit.profit >= 0 && this.oldShopMachineVisit.refill > 0 ? this.oldShopMachineVisit.refill : 0
        tempBank -= this.oldShopMachineVisit.profit + this.oldShopMachineVisit.refill - this.oldShopMachineVisit.physicCashProfit

        tempBalanceToPay -= this.oldShopMachineVisit.shopProfit - this.oldShopMachineVisit.shopProfitDelivey + this.oldShopMachineVisit.depositBalancePayToShop

        if (this.shopMachineVisit.isThisUninstall) {
          this.projectedValues.cashToGo = tempBank + this.shopMachineVisit.profit
        } else {
          this.projectedValues.cashToGo = tempBank - this.shopMachine.initialRefill + this.shopMachineVisit.profit
        }

        this.projectedValues.balanceToPay = tempBalanceToPay
        this.projectedValues.balanceToPay += (this.shopMachineVisit.shopProfit - this.shopMachineVisit.shopProfitDelivey + this.shopMachineVisit.depositBalancePayToShop)

        this.projectedValues.bank = tempBank
        // this.projectedValues.bank += this.shopMachineVisit.profit < 0 && this.shopMachineVisit.refill > 0 && this.shopMachineVisit.refill >= -this.shopMachineVisit.profit ? this.shopMachineVisit.Refill - (-this.shopMachineVisit.profit) : 0
        // this.projectedValues.bank += this.shopMachineVisit.profit >= 0 && this.shopMachineVisit.refill > 0 ? this.shopMachineVisit.refill : 0
        this.projectedValues.bank += this.shopMachineVisit.profit + this.shopMachineVisit.refill - this.shopMachineVisit.physicCashProfit
        // this.projectedValues.balanceToPay =
      },
    },
  }
</script>

<style lang="sass" scoped>
    .projected-values
      color: blue
      font-weight: bold
    .projected-labels
      font-weight: bold
      margin-right: 10px
</style>
